enum ContentGridWidth {
	TwoColumns = '2_columns',
	ThreeColumns = '3_columns',
	FourColumns = '4_columns',
}

export default ContentGridWidth;
